<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Register" />
            <RegisterComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import RegisterComp from '../Register/RegisterComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'RegisterPage',
    components: {
        NavBar,
        PageTitle,
        RegisterComp,
        FooterComp,
    }
}
</script>